// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU5_thecomp__Uhd1W"};